import { useState, useEffect } from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer
} from 'recharts';

import * as apiComms from '../apiComms';
import * as logger from '../logger';

const PROG = 'ChartCollectorCardCompletionRate.js';

const ChartCollectorCardCompletionRate = (props) => {

  const [chartData, setChartData] = useState(null);
  const [isLoadingData, setIsLoadingData] = useState(true);

  useEffect(() => {
    const loadChartData = async () => {
      const FUNCTION = 'loadChartData';
      try {
        setIsLoadingData(true);
        const _chartDataResponse = await apiComms.getChartDataCollectorCardCompletionRate(props.timeRange);
        if (_chartDataResponse && !_chartDataResponse.isErr) {
          const _chartData = _chartDataResponse.response.chartdata;
          setChartData(_parseChartData(_chartData));
        }
        setIsLoadingData(false);
      }
      catch (e) {
        logger.error('Exception Occured', { PROG, FUNCTION });
        console.log('Exception: '+e+', '+e.stack);
      }
    };

    loadChartData();
  }, [props.timeRange]);

  const _parseChartData = (_chartData) => {
    return _chartData.map((_chartDataRec) => ({
      collectorCardId : _chartDataRec.collectorCardId,
      completionRate : Number(_chartDataRec.completionRate ?? 0),
      completedCards : Number(_chartDataRec.completedCards ?? 0),
      totalCards : Number(_chartDataRec.totalCards ?? 0)
    }));
  };

  return (
    <div className='card'>
      <div style={{ display : 'flex', width : '100%', flexDirection : 'column', borderRadius: 10, overflow : 'hidden' }} >
        <div style={{ height : 260 }}>
          {!isLoadingData ? (
            <>
            {Array.isArray(chartData) && chartData.length > 0 ? (
            <ResponsiveContainer>
              <BarChart
                data={chartData}
                margin={{ top: 20, right: 20, left: 6, bottom: 0 }}
              >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="collectorCardId" />
                <YAxis width={42} tickFormatter={ (value) => `${value}%` } />
                <Tooltip
                  formatter={ (value, name) => {
                    if (name === 'completionRate') {
                      return [`${Number(value).toFixed(1)}%`, 'Completion Rate'];
                    }
                    return [value, name];
                  }}
                  labelFormatter={ (label) => label }
                />
                <Bar dataKey="completionRate" fill="#20c997" radius={[4, 4, 0, 0]} />
              </BarChart>
            </ResponsiveContainer>
            ) : null }
            </>
          ) : null }
        </div>
        <div className='card-body'>
          Collector Card Completion Rate
        </div>
      </div>
    </div>
  );
};

export default ChartCollectorCardCompletionRate;
